import { Model } from "@vuex-orm/core";
import { getTicketStatusName } from "../../entity-service/global-status-entity-service";
import { Enums } from "../../helper/enums";
import { clientEntity } from "./client-entity";
import { contactEntity } from "./contact-entity";
import { ticketEntity } from "./ticket-entity";

export interface minimizedItemEntity {
  id: number;
  itemType: number;
  itemId: any; //Type depends on module
  minimizeToLocation: string;
  lastLocation: string;
  lastMaximizedItemId: any;
  isHighlighted: boolean;
  isMaximized: boolean;
  lastMaximized: boolean;
  minimizedDateTime: string;
  pageState: string;
  localItemName: string;
  localCurrency: string;
}

export class minimizedItemEntity extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = "minimizedItemEntity";
  static primaryKey = "id";

  static fields() {
    return {
      id: this.uid(),
      itemType: this.number(0),
      itemId: this.attr(null),
      minimizeToLocation: this.string(""),
      lastLocation: this.attr(null),
      lastMaximizedItemId: this.attr(null),
      isHighlighted: this.boolean(false),
      isMaximized: this.boolean(false),
      lastMaximized: this.boolean(false),
      minimizedDateTime: this.attr(null),
      pageState: this.attr(null),
      localItemName: this.string(""),
      localCurrency: this.string(""),
    };
  }

  get itemName() {
    if (this.itemType != null && this.itemType > 0) {
      switch (this.itemType) {
        case Enums.MinimzedItem.Ticket:
          let ticket = ticketEntity
            .query()
            .where("ticketId", this.itemId)
            .withAllRecursive()
            .first();
          if (ticket) {
            let title = "";
            if (
              ticket.ticketNumberWithPrefix != "" &&
              ticket.ticketNumberWithPrefix != null
            ) {
              title = `<div class='xs--text fw-600'>${ticket.ticketNumberWithPrefix}</div>`;
            }
            title += `<div class='xs--text tertiary--text fw-400'>${ticket.ticketTitle}</div>`;
            return title;
          }
          return "";
        case Enums.MinimzedItem.Contact:
          const contact = contactEntity
            .query()
            .where("contactId", this.itemId)
            .first();
          if (contact) {
            let title = "";
            title = `<span class='xs--text fw-600  text-truncate'>${contact.firstName} ${contact.lastName}</span>`;

            return title;
          }
          return "";
        case Enums.MinimzedItem.ContactCreate:
          return "New Contact";

        case Enums.MinimzedItem.Client:
          const client = clientEntity
            .query<any>()
            .where("clientId", this.itemId)
            .first();
          if (client) {
            let title = "";
            title = `<span class='xs--text fw-600  text-truncate'>${client.clientName} </span>`;

            return title;
          }
          return "";
        case Enums.MinimzedItem.ClientCreate:
          return "New Client";
        case Enums.MinimzedItem.Document:
          if (this.localItemName != "") {
            let title = `<span class='xs--text fw-600 m-wd-145p d-inline-block text-truncate'>${this.localItemName}</span>`;
            return title;
          }
          return "";
        case Enums.MinimzedItem.DocumentCreate:
          return "New Document";
      }
    }
    return "";
  }

  get itemDetail() {
    if (this.itemType != null && this.itemType > 0) {
      switch (this.itemType) {
        case Enums.MinimzedItem.Ticket:
          let ticket = ticketEntity
            .query()
            .where("ticketId", this.itemId)
            .withAllRecursive()
            .first();
          if (ticket) {
            let id = ticket.ticketStatusId;
            let className = "";

            if (id == 1) {
              className = `error`;
            }
            if (id == 2) {
              className = `warningDark`;
            }
            if (id == 3) {
              className = `success`;
            }
            if (id == 4) {
              className = `secondaryLight`;
            }
            if (id == 6) {
              className = `info`;
            }
            if (id == 7) {
              className = `secondary`;
            }
            let details =
              `<div class='row tickettabtooltip'><div class='col-md-12 pa-2'><div class='row no-gutters align-center'><div class='col-6' v-if='${ticket.ticketNumberWithPrefix} != null'>` +
              ticket.ticketNumberWithPrefix +
              `</div><div class='col-6 text-right'><span class='v-chip v-chip--label py-3 px-2  xs--text v-size--small tickettabstatuschip ${className}'> ` +
              getTicketStatusName(ticket.ticketStatusId) +
              "</span> </div> </div> <div class='row no-gutters my-2 align-center'> <div class='col-12 text-truncate tertiary--text '>" +
              ticket.ticketTitle +
              "</div></div> <div class='row no-gutters align-center'>";
            if (ticket.clientEntity != null) {
              details += `<div class="col-6 text-truncate"><i class="fal fa-building mr-2"></i> ${ticket.clientEntity.clientName} </div>`;
            }
            let contact = contactEntity
              .query()
              .where("contactId", ticket.contactId)
              .first();

            if (contact) {
              details += `<div class="col-6 text-right text-truncate"><i class="fal fa-id-card-alt mr-2"></i> ${contact.fullNameWithoutClientName} </div> `;
            }

            details += "</div></div></div>";

            return details;
          }
          return "";
        case Enums.MinimzedItem.Client:
          const client = clientEntity
            .query<any>()
            .where("clientId", this.itemId)
            .first();

          if (client) {
            let details =
              `<div class="row tickettabtooltip"><div class="col-md pa-2 tertiary--text text-truncate">` +
              client.clientName +
              `</div><div class="col-md-auto pa-2 text-right">Billing Name: ${client.billingName}</div>`;
            if (client.clientId != null) {
              details +=
                `<div class="col-md-12 px-2 pt-0"><i class="fal fa-building mr-2"></i>` +
                client.clientId +
                `</div>`;
            }
            details += "</div>";
            return details;
          }
          return "";
        case Enums.MinimzedItem.Document:
          let details =
            `<div class="row tickettabtooltip"><span class="col-md pa-2"><i class="fal fa-file-alt mr-3"></i>` +
            this.localItemName +
            `</span>`;

          details += "</div>";
          return details;
      }
    }
    return "";
  }
}
